import { Body, Controller, Post, Query, Req, Get, Param } from '@nestjs/common';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { ApiHeader, ApiOperation, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { HierarchyService } from './hierarchy.services';
import { getMyNetworkResponseModel } from '../profile/dto/profile-response-model';


ApiTags('hierarchy')
@Controller('hierarchy')
export class HierarchyController{
    constructor(
        private hierarchyService: HierarchyService
    ){}

    //@UseGuards(JwtAuthGuard)
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getMyNetwork/:userId')
    @ApiOperation({summary:'get my network by userId'})
    @ApiParam({name:'userId'})
    @ApiQuery({name:'apiVersion'})
    @ApiQuery({name:'skip'})
    async getMyNetworkByUserId(@Query() queryParams, @Param('userId') userId, @Req() request:Request):Promise<getMyNetworkResponseModel> {
        try {
            return await this.hierarchyService.getMyNetworkByUserId(queryParams, userId, request);
        } catch (error) {
            return errorHandler(getMyNetworkResponseModel, error);
        }
    }

}
